<template>
  <div class="TOP_3">
    <svg class="Fond">
      <rect
        id="Fond"
        rx="20"
        ry="20"
        x="0"
        y="0"
        width="1000"
        height="1000"
      ></rect>
    </svg>
    <div class="Top3">
      <svg
        id="Ellipse_9"
        style="
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          left: 55%;
          top: 25px;
          width: 20%;
        "
        :style="'background-image: url(' + items['IMG3']"
        v-if="items['IMG3'] != ''"
      ></svg>
      <svg id="Ellipse_9" v-if="items['IMG3'] == ''">
        <ellipse id="Top3_s" rx="10%" cx="68%" cy="58%"></ellipse>
      </svg>
      <div
        id="TM"
        :style="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'font-size: 40px'
            : ''
        "
        v-if="items['IMG3'] == ''"
      >
        <span>{{ items["INI3"] }}</span>
      </div>
      <div id="ID3_top">
        <span>3</span>
      </div>
      <img
        id="Down"
        src="../../public/img/Down.png"
        srcset="../../public/img/Down.png 1x, ../../public/img/Down@2x.png 2x"
      />
    </div>
    <div class="Top2">
      <svg
        id="Ellipse_10"
        style="
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          left: 18%;
          top: 25px;
          width: 25%;
        "
        :style="'background-image: url(' + items['IMG2']"
        v-if="items['IMG2'] != ''"
      ></svg>
      <svg id="Ellipse_10" v-if="items['IMG2'] == ''">
        <ellipse id="Top2_w" rx="12%" cx="25%" cy="60%"></ellipse>
      </svg>
      <div
        id="RC"
        v-if="items['IMG2'] == ''"
        :style="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'font-size: 50px'
            : ''
        "
      >
        <span>{{ items["INI2"] }}</span>
      </div>
      <div id="ID2_top">
        <span>2</span>
      </div>
      <img
        id="Equal"
        src="../../public/img/Equal.png"
        srcset="../../public/img/Equal.png 1x, ../../public/img/Equal@2x.png 2x"
      />
    </div>
    <div class="Top1">
      <div id="ID1_top">
        <span>1</span>
      </div>
      <img
        id="Up"
        src="../../public/img/Up.png"
        srcset="../../public/img/Up.png 1x, ../../public/img/Up@2x.png 2x"
      />
      <img
        id="King"
        src="../../public/img/King.png"
        srcset="../../public/img/King.png 1x, ../../public/img/King@2x.png 2x"
      />
      <svg
        id="Ellipse_8"
        style="
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          left: 35%;
          top: 50px;
          width: 30%;
        "
        :style="'background-image: url(' + items['IMG1']"
        v-if="items['IMG2'] != ''"
      ></svg>
      <svg id="Ellipse_8" v-if="items['IMG1'] == ''">
        <ellipse id="Top1_" rx="14.5%" cx="48%" cy="85%"></ellipse>
      </svg>
      <div
        id="SD"
        v-if="items['IMG1'] == ''"
        :style="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? 'font-size: 60px'
            : ''
        "
      >
        <span>{{ items["INI1"] }}</span>
      </div>
    </div>
    <div id="ID1_TOP3">
      <div id="ID1_">
        <span>1</span>
      </div>
      <img
        id="Up_"
        src="../../public/img/Up_.png"
        srcset="../../public/img/Up_.png 1x, ../../public/img/Up_@2x.png 2x"
      />
      <div id="INFO1_TOP3">
        <span>{{ items["NOM1"] }}</span>
      </div>
      <div id="ID1_Value">
        <span>{{ items["VALUE1"] }} {{ devise }}</span>
      </div>
    </div>
    <div id="ID2_TOP3">
      <div id="ID2_ba">
        <span>2</span>
      </div>
      <div id="INFO2_TOP3">
        <span>{{ items["NOM2"] }}</span>
      </div>
      <div id="ID2_Value">
        <span>{{ items["VALUE2"] }} {{ devise }}</span>
      </div>
      <img
        id="Equal_bd"
        src="../../public/img/Equal_bd.png"
        srcset="
          ../../public/img/Equal_bd.png    1x,
          ../../public/img/Equal_bd@2x.png 2x
        "
      />
    </div>
    <div id="ID3_TOP3">
      <div id="ID3_bf">
        <span>3</span>
      </div>
      <img
        id="Down_bg"
        src="../../public/img/Down_bg.png"
        srcset="
          ../../public/img/Down_bg.png    1x,
          ../../public/img/Down_bg@2x.png 2x
        "
      />
      <div id="INFO3_TOP3">
        <span>{{ items["NOM3"] }}</span>
      </div>
      <div id="ID3_Value">
        <span>{{ items["VALUE3"] }} {{ devise }}</span>
      </div>
    </div>
    <div id="TOP3_TITRE">
      <span v-if="items['IMG1'] == ''">TOP 3 des Vendeurs</span>
      <span v-if="items['IMG1'] != ''">TOP 3 des Ventes</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["items", "devise"],
};
</script>
